<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            v-model="alertCredit.show"
            @hidden="alertCredit.show = false"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12 text-center">
                            <h3 class="mb-0">ยอดเครดิตไม่เพียงพอ</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <Icon icon="clarity-wallet-solid" v-bind:style="{color: (this.$THEME.hasOwnProperty('primaryColor')) ? this.$THEME.primaryColor : '#11cdef' , fontSize: '54px'}" />
                        <h4 class="pt-4">ยอดเครดิตปัจจุบัน : {{$WALLET.available_balance | numFormat('0,0.00')}}</h4>
                        <h4 class="pb-4">ยอดเครดิตที่ต้องตัด : {{alertCredit.creditPay | numFormat('0,0.00')}}</h4>
                        <hr class="my-4" />
                        <h4>กรุณาเติมเครดิตให้เพียงพอในการชำระ</h4>
                    </div>
                    <div class="col-lg-12 text-center">
                        <b-button
                            @click="openTopUpWallet()"
                            class="px-5"
                            variant="success" >
                            เติมเครดิต
                        </b-button>
                    </div>
                </div>
            </card>

        </b-modal>
    </div>
</template>
<script>
import { fetchWalletBanlancesToLocalStorage } from "@/axios/walletPayment.js"

export default {
    name: "ModalAlertCredit" ,
    props: {
        alertCredit: Object,
    },

    data(){
        return{
            reCheckWallet: false
        }
    },
    mounted() {
        this.tabActive();
    },
    methods:{
        tabActive(){
            window.addEventListener('focus', () => {
                // on browser tab active
                if (this.reCheckWallet) {
                    this.reCheckWallet = false
                    fetchWalletBanlancesToLocalStorage().then( res => {
                        this.$WALLET.balance           = res.balance
                        this.$WALLET.peg_balance       = res.peg_balance
                        this.$WALLET.available_balance = res.available_balance
                    })
                }
            });
        },
        openTopUpWallet() {
            this.reCheckWallet = true;
            window.open('/topupcredit','_blank')
        },
    }
}
</script>
